import Backbone from 'backbone';
import InsightsUtil from 'utils/insights/insightsUtil';
import Localizer from 'localizer';

var STATUS = InsightsUtil.STATUS;

var Insight = Backbone.Model.extend({
    backend: 'insights',

    url: function() {
        return '/gcs-insights/api/feature/details' + this.addInsightUrlParams();
    },

    initialize: function(attributes, options) {
        this.featureId = attributes.featureId;
        this.createdDateUTC = attributes.createdDateUTC;
    },

    addInsightUrlParams: function() {
        return '?featureId=' + this.featureId + '&date=' + this.createdDateUTC + '&lang=' + Localizer.getLocale();
    },

    save: function(key, value, options) {
        // date is used to properly match the feature since for a given user id there could be more features with the same featureId.
        key['date'] = this.createdDateUTC;
        return Backbone.Model.prototype.save.call(this, key, value, options);
    },

    sync: function(method, model, options) {
        //status can be set to UNREAD, DELETED, READ, FAVORITED, DISMISSED
        if (method === 'create' || method === 'update') {
            options.url = '/gcs-insights/api/feature/status/' + model.attributes.status;
        }

        return Backbone.sync(method, model, options);
    },

    fetch: function(options) {
        options = _.extend(options, {
            headers: { CHART_VER: InsightsUtil.CHART_VER }
        });
        return Backbone.Model.prototype.fetch.apply(this, arguments);
    }
});
Insight.STATUS = STATUS;
export default Insight;
